import { DeliveryItem } from "./deliveryItem/deliveryItem";
import { DeliveryTypesBase } from "./deliveryTypes.base";

export const DeliveryTypes = Object.assign(DeliveryTypesBase, {
    DeliveryItem: DeliveryItem
});
